<template>
  <div
    class="text-xs flex flex-row flex-wrap items-center justify-between gap-x-2 gap-y-0 px-3 py-2 border-t border-gray-200 text-gray-400 leading-tight overflow-hidden transition-opacity duration-150 [&_a:hover]:text-gray-600 [&_a]:transition-colors"
    :class="showContent ? 'opacity-100' : 'opacity-0 pointer-events-none'"
  >
    <div class="flex flex-wrap items-center gap-x-2">
      <a href="https://airtable.com/app6bOthAjF7PEipT/pag1Z1ifluZiqptnx/form" target="_blank" class="whitespace-nowrap">Report issue</a>
      <a href="https://campus.outtalent.com/terms-and-conditions" target="_blank" class="whitespace-nowrap">Terms</a>
      <a href="https://campus.outtalent.com/privacy-policy" target="_blank" class="whitespace-nowrap">Privacy</a>
    </div>
    <span class="whitespace-nowrap">© {{ new Date().getFullYear() }} Outtalent</span>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps<{ collapsed?: boolean }>()

const showContent = ref(!props.collapsed)
let timer: ReturnType<typeof setTimeout>

watch(
  () => props.collapsed,
  (val) => {
    clearTimeout(timer)
    if (val) {
      showContent.value = false
    } else {
      timer = setTimeout(() => {
        showContent.value = true
      }, 300)
    }
  }
)
</script>

